import {USER_LOGIN, USER_LOGOUT} from '../../modules/auth/actions/types';

const initialState = {
    isAuthenticated: false,
    remember: false,
    credentials: {}
};

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case USER_LOGIN: return {
            isAuthenticated: !!action.payload.token,
            remember: action.payload.remember,
            credentials: {
                login: action.payload.login,
                pwdHash: action.payload.pwdHash,
            }
        };
        case USER_LOGOUT: return initialState;
        default: return state;
    }
};




/** WEBPACK FOOTER **
 ** ./src/redux/reducers/auth.js
 **/